import assetPath from '/app/packages/login/layout/src/background-layout/images/hidden-jobs.png';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')